import { apiRequest } from "./client";

export const customersApi = {
  list(projectId, params = {}) {
    return apiRequest(`/projects/${projectId}/customers`, { params });
  },

  get(projectId, customerId) {
    return apiRequest(`/projects/${projectId}/customers/${customerId}`);
  },

  create(projectId, payload) {
    return apiRequest(`/projects/${projectId}/customers`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  updateProfile(projectId, customerId, payload) {
    return apiRequest(`/projects/${projectId}/customers/${customerId}/profile`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  priceLists(projectId) {
    return apiRequest(`/projects/${projectId}/customers/price-lists`);
  },

  priceList(projectId, priceListId) {
    return apiRequest(`/projects/${projectId}/customers/price-lists/${priceListId}`);
  },

  createPriceList(projectId, payload) {
    return apiRequest(`/projects/${projectId}/customers/price-lists`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  updatePriceList(projectId, priceListId, payload) {
    return apiRequest(`/projects/${projectId}/customers/price-lists/${priceListId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  membershipReminders(projectId, options = {}) {
    return apiRequest(`/projects/${projectId}/customers/membership-reminders/sync`, {
      method: "POST",
      body: JSON.stringify({ limit: options.limit || 60 }),
    });
  },

  membershipItems(projectId) {
    return apiRequest(`/projects/${projectId}/customers/membership-items`);
  },

  membershipWorkspace(projectId, params = {}) {
    return apiRequest(`/projects/${projectId}/customers/membership-workspace`, { params });
  },

  memberships(projectId, customerId) {
    return apiRequest(`/projects/${projectId}/customers/${customerId}/memberships`);
  },

  assignMembership(projectId, customerId, payload) {
    const operationKey = String(payload?.operationKey || "").trim();
    return apiRequest(`/projects/${projectId}/customers/${customerId}/memberships`, {
      method: "POST",
      headers: operationKey ? { "Idempotency-Key": operationKey } : undefined,
      body: JSON.stringify(payload),
    });
  },

  recordMembershipPayment(projectId, customerId, membershipId, payload = {}) {
    return apiRequest(`/projects/${projectId}/customers/${customerId}/memberships/${membershipId}/payment`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  recordMembershipUsage(projectId, customerId, membershipId, payload = {}) {
    const operationKey = String(payload?.operationKey || "").trim();
    return apiRequest(`/projects/${projectId}/customers/${customerId}/memberships/${membershipId}/usage`, {
      method: "POST",
      headers: operationKey ? { "Idempotency-Key": operationKey } : undefined,
      body: JSON.stringify(payload),
    });
  },

  updateMembershipStatus(projectId, customerId, membershipId, payload) {
    return apiRequest(`/projects/${projectId}/customers/${customerId}/memberships/${membershipId}/status`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  assignPriceList(projectId, customerId, priceListId, expectedUpdatedAt) {
    return apiRequest(`/projects/${projectId}/customers/${customerId}/price-list`, {
      method: "PATCH",
      body: JSON.stringify({ priceListId, expectedUpdatedAt }),
    });
  },

  updateStatus(projectId, customerId, status, reason, expectedUpdatedAt) {
    return apiRequest(`/projects/${projectId}/customers/${customerId}/status`, {
      method: "PATCH",
      body: JSON.stringify({ status, reason, expectedUpdatedAt }),
    });
  },

  crmConfig(projectId) {
    return apiRequest(`/projects/${projectId}/customers/crm/config`);
  },

  saveCrmConfig(projectId, payload) {
    return apiRequest(`/projects/${projectId}/customers/crm/config`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },

  crmIntegrations(projectId) {
    return apiRequest(`/projects/${projectId}/customers/crm/integrations`);
  },

  saveCrmIntegration(projectId, integrationKey, payload) {
    return apiRequest(`/projects/${projectId}/customers/crm/integrations/${integrationKey}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },

  deleteCrmIntegration(projectId, integrationKey) {
    return apiRequest(`/projects/${projectId}/customers/crm/integrations/${integrationKey}`, { method: "DELETE" });
  },

  activateCrmIntegration(projectId, integrationKey) {
    return apiRequest(`/projects/${projectId}/customers/crm/integrations/${integrationKey}/activate`, { method: "POST" });
  },

  updateCrm(projectId, customerId, payload) {
    return apiRequest(`/projects/${projectId}/customers/${customerId}/crm`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  addCrmActivity(projectId, customerId, payload) {
    return apiRequest(`/projects/${projectId}/customers/${customerId}/crm/activities`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
};
